import { createContext } from 'react';

export const lookupsContext = createContext({});

export default lookupsContext;
